import React from "react";
import { BiLock } from "react-icons/bi";
import styled from "styled-components";
import UserAvatar from "../../../globalComponents/UserAvatar";

interface DiscussionCardProp {
  title: string;
  startedAt?: string;
  roomType: string;
  hostName: string;
  hostImage: string;
  onClick: () => void;
  time: string;
  country: string;
}

function DiscussionCardItem({
  title,
  startedAt,
  onClick,
  roomType,
  hostImage,
  hostName,
  country,
}: DiscussionCardProp) {
  const names = hostName.split(" ");
  return (
    <Container>
      <TopSection>
        <Row>
          <DiscussionTitle>{title}</DiscussionTitle>
          {roomType.toLowerCase() === "PRIVATE".toLowerCase() && (
            <BiLock color="#bd3f26" />
          )}
        </Row>
        <Spacing />
        <DiscussionInfoTitle>
          Started broadcasting 16 minutes ago
        </DiscussionInfoTitle>
        <UserAvatarSection>
          <UserAvatar
            size={60}
            img={hostImage}
            firstname={names[0]}
            lastname={names[1]}
          />
        </UserAvatarSection>
      </TopSection>
      <BottomSection>
        <DiscussionInfoTitle
          style={{ marginBottom: "10px", textTransform: "capitalize" }}
        >
          Room {hostName}. Country: {country}.
        </DiscussionInfoTitle>
        <Row style={{ justifyContent: "space-between" }}>
          <Row>
            <AvatarContainer index={0}>
              <UserAvatar />
            </AvatarContainer>
            <AvatarContainer index={1}>
              <UserAvatar />
            </AvatarContainer>
            <AvatarContainer index={2}>
              <UserAvatar />
            </AvatarContainer>
            <DiscussionFadedText>+666 Others listening</DiscussionFadedText>
          </Row>
          <JoinButton onClick={onClick}>Join</JoinButton>
        </Row>
      </BottomSection>
    </Container>
  );
}

const JoinButton = styled.div`
  background-color: ${(props) => props.theme.tint};
  border-radius: 16px;
  padding: 5px 25px;
  color: white;
  font-weight: 800;
  font-size: 13px;
  cursor: pointer;
  :hover {
    box-shadow: ${(props) => props.theme.subtleShadow};
  }
`;

const DiscussionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  flex: 1;
  color: ${(props) => props.theme.color};
`;

const DiscussionInfoTitle = styled.div`
  font-size: 11px;
  color: ${(props) => props.theme.color};
`;

const DiscussionFadedText = styled.div`
  font-size: 11px;
  color: ${(props) => props.theme.grey};
  margin-left: -30px;
  width: min-content;
`;

const Container = styled.div`
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 320px;
  height: 200px;
  background: ${(props) => props.theme.background};
  box-shadow: ${(props) => props.theme.subtleShadow};
  margin: 10px;
`;

const UserAvatarSection = styled.div`
  position: absolute;
  right: 5px;
  bottom: -30px;
`;

const AvatarContainer = styled.div<{ index: number }>`
  transform: translateX(-${(prop) => prop.index * 17}px);
  /* margin-left: -${(prop) => prop.index * 17}px; */
`;
const TopSection = styled.div`
  position: relative;
  margin-bottom: 10px;
  background: ${(props) => props.theme.foreground};
  padding: 16px;
`;

const BottomSection = styled.div`
  padding: 3px 16px;
`;

const Spacing = styled.div`
  height: 20px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
`;

export default DiscussionCardItem;
